import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import FeatureStrip from "../components/sections/FeatureStrip";
import ScheduleStrip from "../components/sections/ScheduleStrip";
import About from "../components/sections/About";
import Memberships from "../components/sections/Memberships";
import Contact from "../components/sections/Contact";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-[#050505] text-white">
      <Navbar />
      <main>
        <Hero />
        <FeatureStrip />
        <ScheduleStrip />
        <About />
        <Memberships />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
